import { useNavigate, useParams } from 'react-router-dom';
import { KoobCreateButton } from '@koob/ui';
import { useTranslation } from 'react-i18next';
import { useBooking } from '../../../../hooks';
import { folderRoomsComposition } from '@koob/utils';
import { getFolderById } from 'api/node/folder';

export default function CreateBookingButton() {
  const { t } = useTranslation('bookings');
  const { setCustomerFile, setFilters } = useBooking();
  const { clientFolderId } = useParams();
  const navigate = useNavigate();

  return (
    <KoobCreateButton
      onClick={async () => {
        try {
          if (clientFolderId) {
            const folder = await getFolderById({ id: clientFolderId });
            const rooms = folderRoomsComposition(folder?.data);
            setFilters({
              rooms,
            });
            setCustomerFile({
              ...folder?.data,
              customerFileId: clientFolderId,
            });
          } else {
            setFilters({});
          }
        } finally {
          navigate('/bookings/new');
        }
      }}
    >
      {t('newBooking')}
    </KoobCreateButton>
  );
}
